export default {
  hospitals: [
    {
      'active': true,
      'provinceName': '北京',
      'citys': [],
      'cityCnt': 1
    },
    {
      'active': false,
      'provinceName': '天津',
      'citys': [],
      'cityCnt': 1
    },
    {
      'active': false,
      'provinceName': '河北',
      'citys': [],
      'cityCnt': 11
    },
    {
      'active': false,
      'provinceName': '山西',
      'citys': [],
      'cityCnt': 11
    },
    {
      'active': false,
      'provinceName': '内蒙古',
      'citys': [],
      'cityCnt': 12
    },
    {
      'active': false,
      'provinceName': '辽宁',
      'citys': [],
      'cityCnt': 14
    },
    {
      'active': false,
      'provinceName': '吉林',
      'citys': [],
      'cityCnt': 9
    },
    {
      'active': false,
      'provinceName': '黑龙江',
      'citys': [],
      'cityCnt': 13
    },
    {
      'active': false,
      'provinceName': '上海',
      'citys': [],
      'cityCnt': 1
    },
    {
      'active': false,
      'provinceName': '江苏',
      'citys': [],
      'cityCnt': 13
    },
    {
      'active': false,
      'provinceName': '浙江',
      'citys': [],
      'cityCnt': 11
    },
    {
      'active': false,
      'provinceName': '安徽',
      'citys': [],
      'cityCnt': 16
    },
    {
      'active': false,
      'provinceName': '福建',
      'citys': [],
      'cityCnt': 9
    },
    {
      'active': false,
      'provinceName': '江西',
      'citys': [],
      'cityCnt': 11
    },
    {
      'active': false,
      'provinceName': '山东',
      'citys': [],
      'cityCnt': 14
    },
    {
      'active': false,
      'provinceName': '河南',
      'citys': [],
      'cityCnt': 18
    },
    {
      'active': false,
      'provinceName': '湖北',
      'citys': [],
      'cityCnt': 17
    },
    {
      'active': false,
      'provinceName': '湖南',
      'citys': [],
      'cityCnt': 14
    },
    {
      'active': false,
      'provinceName': '广东',
      'citys': [],
      'cityCnt': 21
    },
    {
      'active': false,
      'provinceName': '广西',
      'citys': [],
      'cityCnt': 14
    },
    {
      'active': false,
      'provinceName': '海南',
      'citys': [],
      'cityCnt': 19
    },
    {
      'active': false,
      'provinceName': '重庆',
      'citys': [],
      'cityCnt': 1
    },
    {
      'active': false,
      'provinceName': '四川',
      'citys': [],
      'cityCnt': 21
    },
    {
      'active': false,
      'provinceName': '贵州',
      'citys': [],
      'cityCnt': 9
    },
    {
      'active': false,
      'provinceName': '云南',
      'citys': [],
      'cityCnt': 16
    },
    {
      'active': false,
      'provinceName': '西藏',
      'citys': [],
      'cityCnt': 7
    },
    {
      'active': false,
      'provinceName': '陕西',
      'citys': [],
      'cityCnt': 10
    },
    {
      'active': false,
      'provinceName': '甘肃',
      'citys': [],
      'cityCnt': 14
    },
    {
      'active': false,
      'provinceName': '青海',
      'citys': [],
      'cityCnt': 8
    },
    {
      'active': false,
      'provinceName': '宁夏',
      'citys': [],
      'cityCnt': 5
    },
    {
      'active': false,
      'provinceName': '新疆',
      'citys': [],
      'cityCnt': 16
    }
  ],
  bannerDefault: [
    {
        "imageUrl": "https://static.wecity.qq.com/wapdisease/发热自查-H5-3bdbc0d7ee90d71a64056284cf63164c.png",
        "linkObj": {
            "type": 1,
            "url": "https://feiyan.wecity.qq.com/wuhan/dist/index.html#/selftest?from=lung&_scope=snsapi_base ",
            "appVer": "",
            "appId": ""
        },
        "seq": 2,
        "bannerName": "发热自查",
        "categorySeq": 0,
        "category": "",
        "imageType": 0
    },
    {
        "imageUrl": "https://static.wecity.qq.com/wuhan-static/患者同小区-H5-1-0fa54eab0cf0ec7c6dbb05735cce3fd5.png",
        "linkObj": {
            "type": 1,
            "url": "https://feiyan.wecity.qq.com/wuhan/dist/index.html#/feiyan-act?_scope=snsapi_base&zoom=12",
            "appVer": "",
            "appId": ""
        },
        "seq": 3,
        "bannerName": "患者同小区",
        "categorySeq": 0,
        "category": "",
        "imageType": 0
    },
    // {
    //     "imageUrl": "https://static.wecity.qq.com/wapdisease/口罩攻略-H5-f8c33b3333d1ed285be09945ac9402ab.png",
    //     "linkObj": {
    //         "type": 1,
    //         "url": "https://feiyan.wecity.qq.com/wuhan/dist/index.html#/facemask-apply?_scope=snsapi_base",
    //         "appVer": "",
    //         "appId": ""
    //     },
    //     "seq": 5,
    //     "bannerName": "口罩攻略",
    //     "categorySeq": 0,
    //     "category": "",
    //     "imageType": 0
    // },
    {
        "imageUrl": "https://static.wecity.qq.com/wapdisease/发热门诊-H5-a7ecaa221286103216b5fea85e8eb4ee.png",
        "linkObj": {
            "type": 1,
            "url": "https://feiyan.wecity.qq.com/wuhan/dist/index.html#/map-landing?random=1580397907802&_scope=snsapi_base",
            "appVer": "",
            "appId": ""
        },
        "seq": 8,
        "bannerName": "发热门诊",
        "categorySeq": 0,
        "category": "",
        "imageType": 0
    },
    {
        "imageUrl": "https://static.wecity.qq.com/wapdisease/疫情问答-H5-5c07d3f64eaa50972686c0a3c092eb15.png",
        "linkObj": {
            "type": 1,
            "url": "https://feiyan.wecity.qq.com/wuhan/dist/index.html#/aiqna?from=lung&_scope=snsapi_base",
            "appVer": "",
            "appId": ""
        },
        "seq": 10,
        "bannerName": "疫情问答",
        "categorySeq": 0,
        "category": "",
        "imageType": 0
    }
  ]
}
